import { Component, OnInit } from '@angular/core';
import {LocalDataSource} from 'ng2-smart-table';

@Component({
  selector: 'ngx-delivery-sanitary-equipment',
  templateUrl: './delivery-sanitary-equipment.component.html',
  styleUrls: ['./delivery-sanitary-equipment.component.scss'],
})
export class DeliverySanitaryEquipmentComponent implements OnInit {
  source: LocalDataSource;
  loading: boolean = false;

  settings = {
    actions: false,
    pager: {
      perPage: 10,
    },
    columns: {
      date: {
        title: 'Fecha de entrega',
        filter: true,
      },
      role: {
        title: 'Puesto de trabajo',
        filter: true,
      },
      name: {
        title: 'Nombre del trabajador',
        filter: true,
      },
      equipmentReceived: {
        title: 'Equipo recibido',
        filter: true,
      },
      signature: {
        title: 'Firma de recibido',
        filter: true,
      },
    },
  };
  constructor() { }

  ngOnInit() {
    this.source = new LocalDataSource([
      {
        date: '26 de Abril de 2020',
        name: 'Carlos Cuamatzin',
        role: 'Despachador',
        equipmentReceived: 'Cubrebocas',
        signature: 'Carlos Cuamatzin',
      },
      {
        date: '26 de Abril de 2020',
        name: 'Daniel Tinoco',
        role: 'Despachador',
        equipmentReceived: 'Cubrebocas',
        signature: 'Carlos Cuamatzin',
      },
    ]);
  }

}
